import { Box } from '@mui/material';
import React from 'react';
import { ArrayField, Datagrid, FunctionField } from 'react-admin';
import { ClassroomLocation, GradeKey } from 'src/components/Employees/types';
import { getValueOrPlaceholder } from 'src/utils';

const gradesValuesToString: Record<GradeKey, string> = {
    PRESCHOOL_EDUCATION: 'Дошкільна освіта',
    GRADES_1_TO_4: '1-4 класи',
    GRADES_5_TO_11: '5-11 класи'
};

const orderedGrades: GradeKey[] = ['PRESCHOOL_EDUCATION', 'GRADES_1_TO_4', 'GRADES_5_TO_11'];

const getGradesString = (grades: GradeKey[]): string => {
    const applicableGrades: string[] = [];
    orderedGrades.forEach((orderedGrade: GradeKey) => {
        const classroomGrade = grades.find((gradeEntity: GradeKey) => gradeEntity === orderedGrade);
        classroomGrade && applicableGrades.push(gradesValuesToString[classroomGrade]);
    });

    return applicableGrades.join(', ');
};

const getClassroomLocationTypedRow = (rowData: any): ClassroomLocation => {
    return rowData as ClassroomLocation;
};

const ClassroomLocationsTab: React.FC = () => {
    return (
        <ArrayField source="classroomLocations">
            <Datagrid bulkActionButtons={false}>
                <FunctionField
                    source="name"
                    label="Назва місця"
                    render={(row: any) => {
                        return getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.name);
                    }}
                />
                <FunctionField
                    source="hospitalName"
                    label="Назва лікарні"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.hospitalName)}
                />
                <FunctionField
                    source="building"
                    label="Корпус"
                    textAlign="right"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.building)}
                />
                <FunctionField
                    source="floor"
                    label="Поверх"
                    textAlign="right"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.floor)}
                />
                <FunctionField
                    source="block"
                    label="Блок"
                    textAlign="right"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.block)}
                />
                <FunctionField
                    source="roomNumber"
                    label="№ кабінету"
                    textAlign="right"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.roomNumber)}
                />
                <FunctionField
                    source="maxSeatingCapacity"
                    label="Макс. кількість людей"
                    textAlign="right"
                    render={(row: any) => getValueOrPlaceholder(getClassroomLocationTypedRow(row)?.maxSeatingCapacity)}
                />
                <FunctionField
                    label="Призначене для"
                    render={(row: any) =>
                        getValueOrPlaceholder(
                            getGradesString(getClassroomLocationTypedRow(row)?.targetGradeRange as GradeKey[])
                        )
                    }
                />
            </Datagrid>
        </ArrayField>
    );
};

export default ClassroomLocationsTab;
